import React from "react";
import { useNavigate } from "react-router-dom";
import TransferWindowStatusLine from "../../common/TransferWindowStatusLine";

const StaffTendersMobileHeader = ({
  transferWindowLoading,
  transferWindow,
  formatDateRange,
  dropdownRef,
  searchInputRef,
  searchQuery,
  setSearchQuery,
  handleTransferWindowDropdownToggle,
  countries,
  selectedCountry,
  isTransferWindowDropdownOpen,
  filteredCountries,
  handleCountrySelect,
  staffInClub,
  canCreateTenders,
}) => {
  const navigate = useNavigate();

  const handleCreateTender = () => {
    navigate("/club/tenders/create");
  };

  return (
    <>
      <div className="flex justify-between items-center bg-white px-4 py-2 border-t border-[#0000001A]">
        <div>
          <h1 className="text-base font-bold text-[#000000]">Requests</h1>
        </div>
        {staffInClub && canCreateTenders && (
          <div
            className="bg-[#2283FF] text-white px-4 py-2 rounded-xl"
            onClick={handleCreateTender}
          >
            + Create Request
          </div>
        )}
      </div>

      <div className="flex justify-between items-center py-2 px-4 bg-white">
        <div className="flex items-center">
          <TransferWindowStatusLine
            country={selectedCountry}
            category="mens_professional"
            variant="precise-dates"
            className="text-[#000000CC] text-[10px] font-medium"
          />
        </div>
        <div className="relative" ref={dropdownRef}>
          <button
            className="flex items-center gap-2 px-3 py-1.5 border rounded-lg hover:bg-gray-50"
            onClick={handleTransferWindowDropdownToggle}
          >
            <span>{selectedCountry || "Select country"}</span>
            <svg
              className={`w-4 h-4 transition-transform duration-200 ${
                isTransferWindowDropdownOpen ? "rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {isTransferWindowDropdownOpen && (
            <div className="absolute top-full right-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 z-50 min-w-[250px] overflow-hidden">
              <div className="p-3 border-b border-gray-200">
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg
                      className="h-4 w-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <input
                    ref={searchInputRef}
                    type="text"
                    className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm text-gray-900"
                    placeholder="Search country"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
              <div className="overflow-y-auto max-h-48">
                {filteredCountries.length > 0 ? (
                  filteredCountries
                    .filter((country) => !country.isViewAll)
                    .map((country, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-50 text-gray-700"
                        onClick={() => handleCountrySelect(country)}
                      >
                        <span className="text-sm">{country.name}</span>
                      </div>
                    ))
                ) : (
                  <div className="px-3 py-2 text-gray-500 text-sm">
                    No countries found
                  </div>
                )}
              </div>
              <div
                className="px-3 py-2 cursor-pointer bg-[#2283FF] text-center text-[#F5F5F5]"
                onClick={() => handleCountrySelect({ isViewAll: true })}
              >
                <span className="text-sm font-medium">View All</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default StaffTendersMobileHeader;